// Shared "kit suggerito" logic — used by CartDrawer (su tutti i kit attivi)
// e ProductPage (ristretto ai kit che includono il prodotto visualizzato).
// Riusa bundlePricing per mostrare un risparmio sempre coerente col carrello.
import { bundlePricing } from "./bundlePricing";

// Trova il kit con più prodotti già nel carrello (standalone, non già kit),
// minimo 2 match, escludendo i kit già attivati nel carrello.
export const getBundleSuggestion = (bundles, productsById, cartItems) => {
  if (!bundles?.length || !cartItems || cartItems.length < 2) return null;
  let best = null;
  for (const b of bundles) {
    if (!b.active) continue;
    if (cartItems.some((i) => i.bundle_id === b.id)) continue; // kit già nel carrello
    const ids = (b.items || []).map((it) => it.product_id);
    if (ids.length < 2) continue;
    const matched = ids.filter((pid) => cartItems.some((i) => i.product_id === pid && !i.bundle_id));
    if (matched.length < 2) continue;
    const { savings } = bundlePricing(b, productsById);
    if (!best || matched.length > best.matched || (matched.length === best.matched && savings > best.savings)) {
      best = { bundle: b, matched: matched.length, total: ids.length, savings };
    }
  }
  return best;
};

// Sostituisce le righe singole già nel carrello con il kit completo (prezzo
// fisso/scontato dell'admin), riportando gusto/formato già scelti se ammessi.
export const applyBundleUpgrade = (cart, bundle, productsById) => {
  const flavorChoices = {};
  const sizeChoices = {};
  const toRemove = [];
  (bundle.items || []).forEach((it) => {
    const line = cart.items.find((i) => i.product_id === it.product_id && !i.bundle_id);
    if (line) {
      if (line.flavor) flavorChoices[it.product_id] = line.flavor;
      if (line.size) sizeChoices[it.product_id] = line.size;
      toRemove.push(line.variant_key);
    }
  });
  toRemove.forEach((k) => cart.removeItem(k));
  cart.addBundle(bundle, productsById, flavorChoices, sizeChoices);
};
